import { ProductInfo } from '../models';

const DEFAULT_PRODUCTS: ProductInfo[] = [
  { name: 'SiS Beta Fuel Drink', carbs: 80, type: 'DRINK', availableQuantity: 5, minDivisiblePortionGrams: 20, verified: true, rank: 100, active: true },
  { name: 'SiS Beta Fuel', carbs: 40, type: 'GEL', availableQuantity: 5, verified: true, rank: 90, active: true },
  { name: 'SiS Go Gel', carbs: 22, type: 'GEL', availableQuantity: 5, verified: true, rank: 80, active: true },
  { name: 'Banan', carbs: 27, type: 'FOOD', availableQuantity: 0, active: false },
  { name: 'Żel (generyczny)', carbs: 25, type: 'GEL', availableQuantity: 0, active: false },
  { name: 'Baton energetyczny', carbs: 45, type: 'BAR', availableQuantity: 0, active: false },
  { name: 'Haribo (25g)', carbs: 19, type: 'GUMMY', availableQuantity: 0, minDivisiblePortionGrams: 19, active: false },
];

export function getDefaultProducts(): ProductInfo[] {
  return DEFAULT_PRODUCTS;
}
